export default __webpack_public_path__ + "static/favicon-7697bd904a444d9717b65c287132b548.ico";